import { API_URL } from "../config"

export const apiClient = async(endpoint,options={})=>{

  try{
    const headers = { 
      'ngrok-skip-browser-warning': 'true',
      ...options.headers 
    };
    if (!(options.body instanceof FormData)) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }

    return await fetch(`${API_URL}/${endpoint}`, {
      credentials: 'include',
      ...options,
      headers,
    });
  }catch(error){
    throw error
  }
    
    

}
